<template>
  <div ref="jsonFields" v-if="resourceLoaded">
    <Field
      v-for="(type, index) in types"
      :isLinking="type.linking"
      :data-id="type.dataId"
      :data-group="type.dataGroup"
      :type="type.type"
      :helpText="type.hint"
      :options="type.options"
      :key="`${type}-${index}`"
      v-model="content[type.field]"
      @handleChange="emitData($event, type.field, type)"
      @getPages="getPages"
      :pages="pages"
      :label="label(type)"
      :data-highlight="label(type)"
      :class="{'is-highlighted': isHighlighted(label(type))}"
      :placeholder="type.placeholder"
    />
  </div>
</template>

<script>
import Field from '@/components/Field'

export default {
  name: 'json-fields',

  props: {
    types: Array,
    resource: Object,
    highlightedField: String,
    pages: Array
  },

  data() {
    return {
      content: {},
      resourceLoaded: false
    }
  },

  components: {
    Field
  },

  methods: {
    emitData(event, type, args) {
      if (args.type !== 'textarea') {
        this.handleDynamicEvents(event, type)
      }

      let data = JSON.stringify(this.content)
      this.$emit('update', data)
    },

    getPages() {
      this.$emit('getPages')
    },

    handleDynamicEvents(event, type) {
      let el = event.target
      let value = event.target.value
      let linking = el.parentNode.classList.contains('is-linking')
      let elWrapper = this.$refs.jsonFields

      if (linking) {
        let dataGroup = type.replace(/_/g, '-')
        let dataId = value
        let selectedEl = elWrapper.querySelector(`[data-group="${dataGroup}"][data-id="${dataId}"]`)
        let groupEls = elWrapper.querySelectorAll(`[data-group="${dataGroup}"]`)

        for (let i = 0; i < groupEls.length; i++) {
          groupEls[i].classList.remove('is-active')
        }

        selectedEl.classList.add('is-active')
      }
    },

    initJsonFields() {
      this.types.forEach((type) => {
        let field = type.field
        this.content[field] = JSON.parse(this.resource.value)[field]
      })

      this.resourceLoaded = true
    }
  },

  computed: {
    label() {
      return (type) => {
        return type.field.replace(/_/g, ' ')
      }
    },

    isHighlighted() {
      return (label) => {
        return label === this.highlightedField
      }
    },

    allLoaded() {
      return this.resource && this.types
    }
  },

  watch: {
    allLoaded() {
      this.initJsonFields()
    }
  }
}
</script>

<style lang="sass">
.input[data-id]
  display: none

  &.is-active
    display: block

.is-highlighted
  background: #e4f7e4!important
  border: 1px dotted rgba(0, 0, 0, 0.2)!important
</style>
